<template>
  <transition name="confirm">
    <div v-if="show">
      <div class="dialogbox-mask-h"/>
      <div class="dialogbox-h" :class="[show ? 'fade-in' : 'fade-out']">
        <div class="dialogboxmain-h">
          <div class="dialogbox-confirm-title-h">
            <span>{{title}}</span>
            <i class="el-icon-close confirm-close" @click="close"/>
          </div>
          <div class="dialogbox-confirm-content-h" v-html="content"/>
          <div class="batch">
            批量处理方式：<el-checkbox v-model="checked">批量不通过所有未处理简历</el-checkbox>
          </div>
          <div class="dialogbox-confirm-footer-h">
            <el-button :plain="true" type="info" @click="cancel">{{canceltxt}}</el-button>
            <el-button type="danger" @click="success(checked)">{{confirmtxt}}</el-button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    data() {
      return {
        show: false,
        title: '',
        content: '',
        style: {},
        canceltxt: '取消',
        confirmtxt: '确认',
        checked: false
      }
    },
    methods: {
      close() {
        this.show = false;
      }
    }
  }
</script>

<style lang="less" scoped>
  @import "tpl.less";

  .fade-in {
    animation-name: fade-in;
    animation-duration: 0.3s;
    animation-fill-mode: both;
  }

  .fade-out {
    animation-name: fade-out;
    animation-duration: 0.3s;
    animation-fill-mode: both;
  }

  @keyframes fade-in {
    0% {
      opacity: 0;
      transform: scale(0.8);
    }
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }

  @keyframes fade-out {
    0% {
      opacity: 1;
      transform: scale(1);
    }
    100% {
      opacity: 0;
      transform: scale(0.7);
    }
  }
</style>



// WEBPACK FOOTER //
// tpl.vue?62384b6c